/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { useNegotiationStatusStore } from '../../../../../../../../store/useNegotiationStatusStore';
import { NegotiationSupplierDatapointStatus, NegotitationRowDataProps } from '../../../NegociacaoFornecedor.types';
import { ApprovedButton } from '../ApprovedButton';
import { RejectedButton } from '../RejectedButton';
import { useStatusToggle } from '../hooks/useStatusToggle';
import styles from './ActionButtonsContainer.module.scss';

export interface ActionButtonsContainerProps {
  rowData: NegotitationRowDataProps;
  onStatusChange?: (newStatus: NegotiationSupplierDatapointStatus, updatedRowData: NegotitationRowDataProps) => void;
  disabled?: boolean;
  className?: string;
}

export const ActionButtonsContainer: React.FC<ActionButtonsContainerProps> = ({ rowData, onStatusChange, disabled = false, className = '' }) => {
  const negotiationStatus = useNegotiationStatusStore(state => state.negotiationStatus);

  const { isLoading, currentStatus, handleApprove, handleReject, error } = useStatusToggle({
    rowData,
    onStatusChange,
  });

  const hasValidNewCost = rowData.newCost !== null && rowData.newCost !== undefined && rowData.newCost !== 0;
  const isButtonDisabled = disabled || isLoading || !hasValidNewCost;
  const isClosed = negotiationStatus === 'CLOSED';

  // When negotiation is CLOSED, show only the selected button in display-only mode
  if (isClosed) {
    // If APPROVED, show only ApprovedButton in large display-only mode
    if (currentStatus === 'APPROVED') {
      return (
        <div className={`${styles['action-buttons-container']} ${styles['action-buttons-container--closed']} ${className}`}>
          {error && (
            <div className={styles['error-message']} title={error}>
              ⚠️
            </div>
          )}
          <ApprovedButton
            onClick={() => {}}
            disabled={true}
            currentStatus={currentStatus}
            className={`${styles['action-button']} ${styles['action-button--display-only']}`}
          />
        </div>
      );
    }

    // If DECLINED, show only RejectedButton in large display-only mode
    if (currentStatus === 'DECLINED') {
      return (
        <div className={`${styles['action-buttons-container']} ${styles['action-buttons-container--closed']} ${className}`}>
          {error && (
            <div className={styles['error-message']} title={error}>
              ⚠️
            </div>
          )}
          <RejectedButton
            onClick={() => {}}
            disabled={true}
            currentStatus={currentStatus}
            className={`${styles['action-button']} ${styles['action-button--display-only']}`}
          />
        </div>
      );
    }

    // If null status and CLOSED, show both buttons disabled in default state
    return (
      <div className={`${styles['action-buttons-container']} ${className}`}>
        {error && (
          <div className={styles['error-message']} title={error}>
            ⚠️
          </div>
        )}
        <ApprovedButton onClick={() => {}} disabled={true} currentStatus={currentStatus} className={styles['action-button']} />
        <RejectedButton onClick={() => {}} disabled={true} currentStatus={currentStatus} className={styles['action-button']} />
      </div>
    );
  }

  // When negotiation is ONGOING, show normal interactive buttons
  return (
    <div className={`${styles['action-buttons-container']} ${className}`}>
      {error && (
        <div className={styles['error-message']} title={error}>
          ⚠️
        </div>
      )}
      <ApprovedButton onClick={handleApprove} disabled={isButtonDisabled} currentStatus={currentStatus} className={styles['action-button']} />
      <RejectedButton onClick={handleReject} disabled={isButtonDisabled} currentStatus={currentStatus} className={styles['action-button']} />
    </div>
  );
};
